import { ArtifactDef, ArtifactType, Era, Culture, Rarity } from '../types';

// ── Artifact Pools for all 10 dig sites ──
// 200+ total artifacts, historically plausible

export const ARTIFACT_POOLS: Record<string, ArtifactDef[]> = {

  // ═══════════════════════════════════════════════════════════════
  // SITE 1: DUSTY CREEK — Arizona, Native American settlement
  // ═══════════════════════════════════════════════════════════════
  dusty_creek: [
    {
      id: 'dc_pottery_bowl',
      name: 'Painted Clay Bowl',
      type: 'pottery',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 150,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_01',
      museumAppeal: 3,
      description: 'A shallow bowl with faded red geometric paint. Used for daily meals by a small family group.',
      icon: '🍶'
    },
    {
      id: 'dc_flint_arrowhead',
      name: 'Flint Arrowhead',
      type: 'weapon',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 120,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'dusty_creek_frag_02',
      museumAppeal: 2,
      description: 'A carefully knapped flint point, still sharp after centuries in the dry earth.',
      icon: '🔺'
    },
    {
      id: 'dc_grinding_stone',
      name: 'Mano Grinding Stone',
      type: 'tool',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 200,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'dusty_creek_frag_03',
      museumAppeal: 3,
      description: 'A smooth hand-held stone worn concave from years of grinding maize into flour.',
      icon: '🪨'
    },
    {
      id: 'dc_shell_beads',
      name: 'Shell Bead Necklace',
      type: 'jewelry',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 300,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_04',
      museumAppeal: 5,
      description: 'Tiny disc beads drilled from Gulf Coast shells, evidence of long-distance trade networks.',
      icon: '📿'
    },
    {
      id: 'dc_basket_fragment',
      name: 'Woven Basket Fragment',
      type: 'art',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 180,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_05',
      museumAppeal: 4,
      description: 'A section of tightly woven yucca fiber basket, preserved by the arid climate.',
      icon: '🧺'
    },
    {
      id: 'dc_obsidian_scraper',
      name: 'Obsidian Scraper',
      type: 'tool',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 250,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'dusty_creek_frag_06',
      museumAppeal: 3,
      description: 'A razor-sharp obsidian flake used for scraping hides. The volcanic glass came from distant mountains.',
      icon: '🔪'
    },
    {
      id: 'dc_metate',
      name: 'Metate Stone Slab',
      type: 'tool',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 280,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'dusty_creek_frag_07',
      museumAppeal: 4,
      description: 'A large flat stone with a deep trough worn by generations of grain grinding.',
      icon: '🪨'
    },
    {
      id: 'dc_turquoise_pendant',
      name: 'Turquoise Pendant',
      type: 'jewelry',
      era: 'bronze_age',
      culture: 'native_american',
      baseValue: 800,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_08',
      museumAppeal: 7,
      description: 'A polished turquoise stone set in a carved bone frame. Likely worn by a community leader.',
      icon: '💎'
    },
    {
      id: 'dc_pottery_ladle',
      name: 'Black-on-White Ladle',
      type: 'pottery',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 200,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_09',
      museumAppeal: 4,
      description: 'A small pottery ladle with distinctive black geometric designs on white slip.',
      icon: '🥄'
    },
    {
      id: 'dc_bone_awl',
      name: 'Bone Awl',
      type: 'bone',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 130,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_10',
      museumAppeal: 2,
      description: 'A sharpened deer bone used for punching holes in leather and woven materials.',
      icon: '🦴'
    },
    {
      id: 'dc_fire_pit_stones',
      name: 'Arranged Fire Pit Stones',
      type: 'structure',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 100,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'dusty_creek_frag_11',
      museumAppeal: 2,
      description: 'A ring of fire-cracked stones from a communal cooking hearth.',
      icon: '🔥'
    },
    {
      id: 'dc_clay_figurine',
      name: 'Clay Animal Figurine',
      type: 'art',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 450,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_12',
      museumAppeal: 6,
      description: 'A small fired-clay figure of a desert bighorn sheep, possibly a ritual offering.',
      icon: '🐑'
    },
    {
      id: 'dc_stone_axe',
      name: 'Polished Stone Axe Head',
      type: 'tool',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 350,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'dusty_creek_frag_13',
      museumAppeal: 4,
      description: 'A carefully ground and polished stone axe head with a groove for hafting.',
      icon: '🪓'
    },
    {
      id: 'dc_corn_cob',
      name: 'Preserved Maize Cob',
      type: 'bone',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 160,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_14',
      museumAppeal: 3,
      description: 'A desiccated corn cob showing early domesticated maize varieties.',
      icon: '🌽'
    },
    {
      id: 'dc_pictograph_stone',
      name: 'Pictograph Stone Slab',
      type: 'art',
      era: 'bronze_age',
      culture: 'native_american',
      baseValue: 1200,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_15',
      museumAppeal: 8,
      description: 'A flat sandstone slab covered in petroglyphs depicting a hunt scene and celestial symbols.',
      icon: '🎨'
    },
    {
      id: 'dc_prayer_stick',
      name: 'Feathered Prayer Stick',
      type: 'religious',
      era: 'bronze_age',
      culture: 'native_american',
      baseValue: 600,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_16',
      museumAppeal: 6,
      description: 'A carved wooden stick adorned with feathers and pigment, used in rain ceremonies.',
      icon: '🪶'
    },
    {
      id: 'dc_copper_bell',
      name: 'Copper Trade Bell',
      type: 'jewelry',
      era: 'bronze_age',
      culture: 'native_american',
      baseValue: 2500,
      rarity: 'legendary',
      fragile: false,
      storyFragmentId: 'dusty_creek_frag_17',
      museumAppeal: 9,
      description: 'A tiny copper bell traded from Mesoamerica, evidence of vast continental exchange routes.',
      icon: '🔔'
    },
    {
      id: 'dc_sandal_fragment',
      name: 'Woven Yucca Sandal',
      type: 'art',
      era: 'neolithic',
      culture: 'native_american',
      baseValue: 170,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_18',
      museumAppeal: 3,
      description: 'A remarkably intact yucca-fiber sandal, shaped to fit a small adult foot.',
      icon: '👡'
    },
    {
      id: 'dc_polychrome_jar',
      name: 'Polychrome Storage Jar',
      type: 'pottery',
      era: 'bronze_age',
      culture: 'native_american',
      baseValue: 900,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_19',
      museumAppeal: 7,
      description: 'A large jar painted in three colors with interlocking spiral motifs. A masterwork of pueblo pottery.',
      icon: '🏺'
    },
    {
      id: 'dc_macaw_feather_bundle',
      name: 'Macaw Feather Bundle',
      type: 'religious',
      era: 'bronze_age',
      culture: 'native_american',
      baseValue: 5000,
      rarity: 'mythical',
      fragile: true,
      storyFragmentId: 'dusty_creek_frag_20',
      museumAppeal: 10,
      description: 'A cache of scarlet macaw feathers wrapped in cotton cloth. These tropical birds were bred hundreds of miles to the south.',
      icon: '🦜'
    },
  ],

  // ═══════════════════════════════════════════════════════════════
  // SITE 2: MILLBROOK FARM — England, Roman-era villa
  // ═══════════════════════════════════════════════════════════════
  millbrook_farm: [
    {
      id: 'mf_roman_coin_common',
      name: 'Worn Bronze Sestertius',
      type: 'coin',
      era: 'classical',
      culture: 'roman',
      baseValue: 200,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_01',
      museumAppeal: 3,
      description: 'A heavily circulated bronze coin bearing the profile of an indistinct emperor.',
      icon: '🪙'
    },
    {
      id: 'mf_mosaic_tile',
      name: 'Mosaic Tesserae Cluster',
      type: 'art',
      era: 'classical',
      culture: 'roman',
      baseValue: 180,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'millbrook_farm_frag_02',
      museumAppeal: 4,
      description: 'A cluster of small colored stone tiles still set in mortar, showing a geometric border pattern.',
      icon: '🟫'
    },
    {
      id: 'mf_samian_ware',
      name: 'Samian Ware Bowl',
      type: 'pottery',
      era: 'classical',
      culture: 'roman',
      baseValue: 350,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'millbrook_farm_frag_03',
      museumAppeal: 5,
      description: 'Fine red-gloss pottery imported from Gaul, decorated with hunting scenes in relief.',
      icon: '🍶'
    },
    {
      id: 'mf_iron_nail',
      name: 'Iron Roofing Nail',
      type: 'tool',
      era: 'classical',
      culture: 'roman',
      baseValue: 80,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_04',
      museumAppeal: 1,
      description: 'A hand-forged iron nail, heavily corroded but recognizable as Roman construction hardware.',
      icon: '📌'
    },
    {
      id: 'mf_bronze_fibula',
      name: 'Bronze Cloak Fibula',
      type: 'jewelry',
      era: 'classical',
      culture: 'roman',
      baseValue: 400,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_05',
      museumAppeal: 5,
      description: 'A decorative brooch pin used to fasten a toga or cloak, shaped like a crossbow.',
      icon: '📎'
    },
    {
      id: 'mf_amphora_handle',
      name: 'Amphora Handle Fragment',
      type: 'pottery',
      era: 'classical',
      culture: 'roman',
      baseValue: 120,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_06',
      museumAppeal: 2,
      description: 'The handle of a large transport amphora, stamped with a potter\'s mark from Hispania.',
      icon: '🏺'
    },
    {
      id: 'mf_hypocaust_tile',
      name: 'Hypocaust Pillar Tile',
      type: 'structure',
      era: 'classical',
      culture: 'roman',
      baseValue: 250,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_07',
      museumAppeal: 4,
      description: 'A square brick pillar tile from the underfloor heating system of the villa\'s bathhouse.',
      icon: '🧱'
    },
    {
      id: 'mf_strigil',
      name: 'Bronze Strigil',
      type: 'tool',
      era: 'classical',
      culture: 'roman',
      baseValue: 500,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_08',
      museumAppeal: 5,
      description: 'A curved bronze scraping tool used to clean oil and dirt from the skin after bathing.',
      icon: '🔧'
    },
    {
      id: 'mf_mortaria',
      name: 'Mortaria Mixing Bowl',
      type: 'pottery',
      era: 'classical',
      culture: 'roman',
      baseValue: 160,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'millbrook_farm_frag_09',
      museumAppeal: 3,
      description: 'A heavy kitchen bowl with grit embedded in the interior for grinding herbs and spices.',
      icon: '🥣'
    },
    {
      id: 'mf_silver_denarius',
      name: 'Silver Denarius of Hadrian',
      type: 'coin',
      era: 'classical',
      culture: 'roman',
      baseValue: 1500,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_10',
      museumAppeal: 7,
      description: 'A well-preserved silver coin showing Emperor Hadrian, minted during his visit to Britannia.',
      icon: '🪙'
    },
    {
      id: 'mf_glass_perfume_bottle',
      name: 'Blue Glass Perfume Flask',
      type: 'art',
      era: 'classical',
      culture: 'roman',
      baseValue: 700,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'millbrook_farm_frag_11',
      museumAppeal: 6,
      description: 'A delicate blown-glass flask in cobalt blue, used to store expensive imported perfume.',
      icon: '🧴'
    },
    {
      id: 'mf_bone_dice',
      name: 'Carved Bone Dice Pair',
      type: 'bone',
      era: 'classical',
      culture: 'roman',
      baseValue: 300,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'millbrook_farm_frag_12',
      museumAppeal: 5,
      description: 'Two small bone dice with drilled pip marks. Romans were famously enthusiastic gamblers.',
      icon: '🎲'
    },
    {
      id: 'mf_lead_curse_tablet',
      name: 'Lead Curse Tablet',
      type: 'document',
      era: 'classical',
      culture: 'roman',
      baseValue: 1800,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'millbrook_farm_frag_13',
      museumAppeal: 8,
      description: 'A thin lead sheet inscribed with a Latin curse asking the gods to punish a thief who stole a cloak.',
      icon: '📜'
    },
    {
      id: 'mf_mosaic_dolphin',
      name: 'Mosaic Dolphin Panel',
      type: 'art',
      era: 'classical',
      culture: 'roman',
      baseValue: 2200,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'millbrook_farm_frag_14',
      museumAppeal: 8,
      description: 'An intact mosaic section depicting a pair of dolphins, likely from the villa\'s reception hall.',
      icon: '🐬'
    },
    {
      id: 'mf_iron_stylus',
      name: 'Iron Writing Stylus',
      type: 'tool',
      era: 'classical',
      culture: 'roman',
      baseValue: 220,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_15',
      museumAppeal: 3,
      description: 'A pointed iron stylus for writing on wax tablets, with a flat end for erasing mistakes.',
      icon: '✒️'
    },
    {
      id: 'mf_jet_bracelet',
      name: 'Whitby Jet Bracelet',
      type: 'jewelry',
      era: 'classical',
      culture: 'roman',
      baseValue: 900,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'millbrook_farm_frag_16',
      museumAppeal: 7,
      description: 'A polished black jet bracelet, carved from fossil wood found on the Yorkshire coast.',
      icon: '⚫'
    },
    {
      id: 'mf_gold_aureus',
      name: 'Gold Aureus Coin',
      type: 'coin',
      era: 'classical',
      culture: 'roman',
      baseValue: 8000,
      rarity: 'legendary',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_17',
      museumAppeal: 9,
      description: 'A gold coin of extraordinary value, likely hidden during a time of crisis and never recovered.',
      icon: '💰'
    },
    {
      id: 'mf_oyster_shells',
      name: 'Oyster Shell Midden',
      type: 'bone',
      era: 'classical',
      culture: 'roman',
      baseValue: 90,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_18',
      museumAppeal: 1,
      description: 'A cluster of oyster shells from a refuse heap. Romans imported oysters even to inland villas.',
      icon: '🦪'
    },
    {
      id: 'mf_lararium_statue',
      name: 'Lararium Bronze Figurine',
      type: 'religious',
      era: 'classical',
      culture: 'roman',
      baseValue: 3500,
      rarity: 'legendary',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_19',
      museumAppeal: 9,
      description: 'A small bronze figure of a household god from the villa\'s private shrine, still bearing traces of gilt.',
      icon: '🗿'
    },
    {
      id: 'mf_military_diploma',
      name: 'Bronze Military Diploma',
      type: 'document',
      era: 'classical',
      culture: 'roman',
      baseValue: 12000,
      rarity: 'mythical',
      fragile: false,
      storyFragmentId: 'millbrook_farm_frag_20',
      museumAppeal: 10,
      description: 'Two bronze tablets granting Roman citizenship to an auxiliary soldier upon discharge. Names and witnesses are legible.',
      icon: '📋'
    },
  ],

  // ═══════════════════════════════════════════════════════════════
  // SITE 3: SUNKEN TEMPLE — Yucatan, Mayan temple
  // ═══════════════════════════════════════════════════════════════
  sunken_temple: [
    {
      id: 'st_clay_pot',
      name: 'Painted Ceremonial Pot',
      type: 'pottery',
      era: 'classical',
      culture: 'mayan',
      baseValue: 250,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_01',
      museumAppeal: 4,
      description: 'A cylindrical vessel painted with a palace scene showing nobles drinking chocolate.',
      icon: '🏺'
    },
    {
      id: 'st_obsidian_blade',
      name: 'Obsidian Ritual Blade',
      type: 'weapon',
      era: 'classical',
      culture: 'mayan',
      baseValue: 400,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_02',
      museumAppeal: 5,
      description: 'A leaf-shaped obsidian blade with a prismatic edge, used in bloodletting rituals.',
      icon: '🗡️'
    },
    {
      id: 'st_jade_bead',
      name: 'Jade Bead',
      type: 'jewelry',
      era: 'classical',
      culture: 'mayan',
      baseValue: 350,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'sunken_temple_frag_03',
      museumAppeal: 4,
      description: 'A spherical jade bead drilled through the center. Jade was more precious than gold to the Maya.',
      icon: '🟢'
    },
    {
      id: 'st_limestone_glyph',
      name: 'Hieroglyphic Block',
      type: 'document',
      era: 'classical',
      culture: 'mayan',
      baseValue: 300,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'sunken_temple_frag_04',
      museumAppeal: 5,
      description: 'A carved limestone block bearing a date inscription in the Long Count calendar.',
      icon: '🔤'
    },
    {
      id: 'st_incense_burner',
      name: 'Effigy Incense Burner',
      type: 'religious',
      era: 'classical',
      culture: 'mayan',
      baseValue: 500,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_05',
      museumAppeal: 6,
      description: 'A tall ceramic burner shaped like the rain god Chaak, with hollow chambers for copal resin.',
      icon: '🕯️'
    },
    {
      id: 'st_flint_eccentric',
      name: 'Flint Eccentric',
      type: 'religious',
      era: 'classical',
      culture: 'mayan',
      baseValue: 600,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_06',
      museumAppeal: 7,
      description: 'A chipped flint shaped into the profile of a deity, deposited as a temple offering.',
      icon: '🔱'
    },
    {
      id: 'st_stucco_mask_frag',
      name: 'Stucco Mask Fragment',
      type: 'art',
      era: 'classical',
      culture: 'mayan',
      baseValue: 200,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_07',
      museumAppeal: 4,
      description: 'A painted plaster fragment showing part of a large facade mask, probably a sun deity.',
      icon: '🎭'
    },
    {
      id: 'st_shell_trumpet',
      name: 'Conch Shell Trumpet',
      type: 'art',
      era: 'classical',
      culture: 'mayan',
      baseValue: 350,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_08',
      museumAppeal: 5,
      description: 'A large conch shell with the tip cut off to serve as a mouthpiece for ritual processions.',
      icon: '🐚'
    },
    {
      id: 'st_pottery_whistle',
      name: 'Ceramic Whistle Figurine',
      type: 'pottery',
      era: 'classical',
      culture: 'mayan',
      baseValue: 280,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_09',
      museumAppeal: 5,
      description: 'A small hollow figurine of a ballplayer that produces a shrill tone when blown.',
      icon: '🎵'
    },
    {
      id: 'st_cacao_vessel',
      name: 'Cacao Drinking Vessel',
      type: 'pottery',
      era: 'classical',
      culture: 'mayan',
      baseValue: 450,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_10',
      museumAppeal: 6,
      description: 'A tall cylinder inscribed with glyphs reading "the drinking cup for cacao of the lord."',
      icon: '🍫'
    },
    {
      id: 'st_stingray_spine',
      name: 'Stingray Spine Bloodletter',
      type: 'religious',
      era: 'classical',
      culture: 'mayan',
      baseValue: 300,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_11',
      museumAppeal: 4,
      description: 'A polished stingray spine used by royalty for auto-sacrifice bloodletting rituals.',
      icon: '🩸'
    },
    {
      id: 'st_jade_pectoral',
      name: 'Jade Pectoral Ornament',
      type: 'jewelry',
      era: 'classical',
      culture: 'mayan',
      baseValue: 2500,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'sunken_temple_frag_12',
      museumAppeal: 8,
      description: 'A large carved jade plaque depicting a maize god, drilled for suspension as a chest ornament.',
      icon: '💚'
    },
    {
      id: 'st_calendar_stone',
      name: 'Calendar Round Stone',
      type: 'document',
      era: 'medieval',
      culture: 'mayan',
      baseValue: 1800,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'sunken_temple_frag_13',
      museumAppeal: 8,
      description: 'A circular carved stone showing interlocking calendar wheels marking a significant date.',
      icon: '📅'
    },
    {
      id: 'st_gold_nose_ring',
      name: 'Gold Nose Ornament',
      type: 'jewelry',
      era: 'medieval',
      culture: 'mayan',
      baseValue: 1500,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'sunken_temple_frag_14',
      museumAppeal: 7,
      description: 'A hammered gold nose ring recovered from the cenote, likely a Postclassic offering.',
      icon: '👃'
    },
    {
      id: 'st_ballgame_yoke',
      name: 'Stone Ballgame Yoke',
      type: 'art',
      era: 'classical',
      culture: 'mayan',
      baseValue: 1200,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'sunken_temple_frag_15',
      museumAppeal: 7,
      description: 'A U-shaped stone yoke worn during the ritual ballgame, carved with intertwined serpents.',
      icon: '⚽'
    },
    {
      id: 'st_jade_mosaic_mask',
      name: 'Jade Mosaic Funeral Mask',
      type: 'art',
      era: 'classical',
      culture: 'mayan',
      baseValue: 8000,
      rarity: 'legendary',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_16',
      museumAppeal: 10,
      description: 'A mosaic mask of jade tesserae with shell eyes and obsidian pupils, placed over a king\'s face at burial.',
      icon: '👑'
    },
    {
      id: 'st_obsidian_mirror',
      name: 'Obsidian Scrying Mirror',
      type: 'religious',
      era: 'classical',
      culture: 'mayan',
      baseValue: 3500,
      rarity: 'legendary',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_17',
      museumAppeal: 9,
      description: 'A polished obsidian disc used by priests to commune with the spirit world. Its surface still gleams.',
      icon: '🪞'
    },
    {
      id: 'st_painted_capstone',
      name: 'Painted Vault Capstone',
      type: 'structure',
      era: 'classical',
      culture: 'mayan',
      baseValue: 180,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'sunken_temple_frag_18',
      museumAppeal: 3,
      description: 'A wedge-shaped limestone capstone from a corbeled arch, with faded red handprints.',
      icon: '🧱'
    },
    {
      id: 'st_codex_fragment',
      name: 'Bark Paper Codex Fragment',
      type: 'document',
      era: 'medieval',
      culture: 'mayan',
      baseValue: 15000,
      rarity: 'mythical',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_19',
      museumAppeal: 10,
      description: 'A fragment of folded bark paper covered in glyphic writing and astronomical tables. Only four Maya codices are known to exist.',
      icon: '📕'
    },
    {
      id: 'st_ceramic_plate',
      name: 'Polychrome Tripod Plate',
      type: 'pottery',
      era: 'classical',
      culture: 'mayan',
      baseValue: 220,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'sunken_temple_frag_20',
      museumAppeal: 4,
      description: 'A three-legged plate painted with a mythological scene of the Hero Twins in the underworld.',
      icon: '🍽️'
    },
  ],

  // ═══════════════════════════════════════════════════════════════
  // SITE 4: SILK ROAD — Uzbekistan, trading post
  // ═══════════════════════════════════════════════════════════════
  silk_road: [
    {
      id: 'sr_chinese_silk',
      name: 'Fragment of Chinese Silk',
      type: 'art',
      era: 'classical',
      culture: 'multi_cultural',
      baseValue: 400,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'silk_road_frag_01',
      museumAppeal: 6,
      description: 'A fragment of woven silk with a cloud motif, preserved by the dry desert air.',
      icon: '🧵'
    },
    {
      id: 'sr_roman_glass',
      name: 'Roman Glass Vessel Fragment',
      type: 'art',
      era: 'classical',
      culture: 'multi_cultural',
      baseValue: 350,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'silk_road_frag_02',
      museumAppeal: 5,
      description: 'Iridescent Roman blown glass, found thousands of miles from its Mediterranean origin.',
      icon: '🫗'
    },
    {
      id: 'sr_persian_coin',
      name: 'Sassanid Silver Drachm',
      type: 'coin',
      era: 'classical',
      culture: 'multi_cultural',
      baseValue: 500,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'silk_road_frag_03',
      museumAppeal: 5,
      description: 'A thin silver coin showing a Sassanid king with an elaborate crown and fire altar.',
      icon: '🪙'
    },
    {
      id: 'sr_spice_jar',
      name: 'Glazed Spice Jar',
      type: 'pottery',
      era: 'medieval',
      culture: 'multi_cultural',
      baseValue: 200,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'silk_road_frag_04',
      museumAppeal: 3,
      description: 'A small turquoise-glazed jar that still carries a faint aroma of long-vanished pepper.',
      icon: '🫙'
    },
    {
      id: 'sr_buddhist_figurine',
      name: 'Gandharan Buddha Head',
      type: 'religious',
      era: 'classical',
      culture: 'multi_cultural',
      baseValue: 1200,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'silk_road_frag_05',
      museumAppeal: 8,
      description: 'A stucco Buddha head showing Greek-influenced features, from the Gandharan art tradition.',
      icon: '🧘'
    },
    {
      id: 'sr_bronze_weight',
      name: 'Merchant\'s Bronze Weight',
      type: 'tool',
      era: 'medieval',
      culture: 'multi_cultural',
      baseValue: 150,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'silk_road_frag_06',
      museumAppeal: 2,
      description: 'A small bronze balance weight stamped with a merchant\'s mark for verifying coin weights.',
      icon: '⚖️'
    },
    {
      id: 'sr_lapis_bead',
      name: 'Lapis Lazuli Beads',
      type: 'jewelry',
      era: 'classical',
      culture: 'multi_cultural',
      baseValue: 300,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'silk_road_frag_07',
      museumAppeal: 4,
      description: 'Brilliant blue stone beads from Afghan mines, polished and drilled for stringing.',
      icon: '🔵'
    },
    {
      id: 'sr_clay_seal',
      name: 'Clay Bulla Seal',
      type: 'document',
      era: 'classical',
      culture: 'multi_cultural',
      baseValue: 250,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'silk_road_frag_08',
      museumAppeal: 4,
      description: 'A clay seal impression that once secured a trade document, bearing Sogdian script.',
      icon: '🔏'
    },
    {
      id: 'sr_camel_bell',
      name: 'Bronze Camel Bell',
      type: 'tool',
      era: 'medieval',
      culture: 'multi_cultural',
      baseValue: 180,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'silk_road_frag_09',
      museumAppeal: 3,
      description: 'A dented bronze bell hung around a camel\'s neck to locate the animal in sandstorms.',
      icon: '🔔'
    },
    {
      id: 'sr_tang_mirror',
      name: 'Tang Dynasty Bronze Mirror',
      type: 'art',
      era: 'medieval',
      culture: 'multi_cultural',
      baseValue: 900,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'silk_road_frag_10',
      museumAppeal: 7,
      description: 'A circular bronze mirror with a grape-vine pattern on the back, a Chinese luxury export.',
      icon: '🪞'
    },
    {
      id: 'sr_bone_comb',
      name: 'Carved Bone Comb',
      type: 'bone',
      era: 'medieval',
      culture: 'multi_cultural',
      baseValue: 130,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'silk_road_frag_11',
      museumAppeal: 2,
      description: 'A fine-toothed bone comb, a personal grooming item lost by a traveler centuries ago.',
      icon: '🦴'
    },
    {
      id: 'sr_celadon_bowl',
      name: 'Chinese Celadon Bowl',
      type: 'pottery',
      era: 'medieval',
      culture: 'multi_cultural',
      baseValue: 600,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'silk_road_frag_12',
      museumAppeal: 6,
      description: 'A jade-green glazed bowl from a Song dynasty kiln, prized across all of Asia.',
      icon: '🍵'
    },
    {
      id: 'sr_sogdian_letter',
      name: 'Sogdian Merchant Letter',
      type: 'document',
      era: 'classical',
      culture: 'multi_cultural',
      baseValue: 2000,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'silk_road_frag_13',
      museumAppeal: 8,
      description: 'A fragment of a merchant\'s letter written in Sogdian script on Chinese paper, describing trade goods and prices.',
      icon: '📜'
    },
    {
      id: 'sr_kushan_coin',
      name: 'Kushan Gold Coin',
      type: 'coin',
      era: 'classical',
      culture: 'multi_cultural',
      baseValue: 2500,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'silk_road_frag_14',
      museumAppeal: 7,
      description: 'A gold coin showing a Kushan king with both Greek text and Indian symbols on its faces.',
      icon: '💰'
    },
    {
      id: 'sr_pottery_sherd',
      name: 'Glazed Pottery Shard',
      type: 'pottery',
      era: 'medieval',
      culture: 'multi_cultural',
      baseValue: 100,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'silk_road_frag_15',
      museumAppeal: 2,
      description: 'A fragment of Islamic glazed pottery with cobalt blue calligraphy.',
      icon: '🟦'
    },
    {
      id: 'sr_ivory_chess_piece',
      name: 'Ivory Chess Piece',
      type: 'art',
      era: 'medieval',
      culture: 'multi_cultural',
      baseValue: 1500,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'silk_road_frag_16',
      museumAppeal: 7,
      description: 'A carved ivory elephant from an early chess set, showing the game\'s journey from India westward.',
      icon: '♟️'
    },
    {
      id: 'sr_carnelian_seal',
      name: 'Carnelian Intaglio Seal',
      type: 'jewelry',
      era: 'classical',
      culture: 'multi_cultural',
      baseValue: 800,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'silk_road_frag_17',
      museumAppeal: 6,
      description: 'A polished red gemstone carved with a Greek deity, used by a merchant as a personal seal.',
      icon: '🔴'
    },
    {
      id: 'sr_nestorian_cross',
      name: 'Nestorian Bronze Cross',
      type: 'religious',
      era: 'medieval',
      culture: 'multi_cultural',
      baseValue: 3000,
      rarity: 'legendary',
      fragile: false,
      storyFragmentId: 'silk_road_frag_18',
      museumAppeal: 9,
      description: 'A bronze cross blending Christian and Central Asian motifs, evidence of Nestorian missionaries on the Silk Road.',
      icon: '✝️'
    },
    {
      id: 'sr_bilingual_inscription',
      name: 'Bilingual Stone Inscription',
      type: 'document',
      era: 'classical',
      culture: 'multi_cultural',
      baseValue: 7000,
      rarity: 'legendary',
      fragile: false,
      storyFragmentId: 'silk_road_frag_19',
      museumAppeal: 9,
      description: 'A stone tablet inscribed in both Greek and Aramaic, a Rosetta Stone of the eastern trade routes.',
      icon: '🪨'
    },
    {
      id: 'sr_manichean_scroll',
      name: 'Manichaean Illuminated Scroll',
      type: 'document',
      era: 'medieval',
      culture: 'multi_cultural',
      baseValue: 20000,
      rarity: 'mythical',
      fragile: true,
      storyFragmentId: 'silk_road_frag_20',
      museumAppeal: 10,
      description: 'A brilliantly painted scroll from the extinct Manichaean religion, with text in three scripts. Fewer than a dozen survive.',
      icon: '📿'
    },
  ],

  // ═══════════════════════════════════════════════════════════════
  // SITE 5: FROZEN CAIRN — Norway, Viking burial mound
  // ═══════════════════════════════════════════════════════════════
  frozen_cairn: [
    {
      id: 'fc_iron_rivet',
      name: 'Iron Ship Rivet',
      type: 'tool',
      era: 'medieval',
      culture: 'viking',
      baseValue: 100,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_01',
      museumAppeal: 2,
      description: 'A corroded iron rivet from a clinker-built longship, bent at the shank from original clenching.',
      icon: '🔩'
    },
    {
      id: 'fc_whetstone',
      name: 'Soapstone Whetstone',
      type: 'tool',
      era: 'medieval',
      culture: 'viking',
      baseValue: 120,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_02',
      museumAppeal: 2,
      description: 'A rectangular soapstone whetstone worn smooth from years of blade sharpening.',
      icon: '🪨'
    },
    {
      id: 'fc_amber_bead',
      name: 'Baltic Amber Bead',
      type: 'jewelry',
      era: 'medieval',
      culture: 'viking',
      baseValue: 250,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_03',
      museumAppeal: 4,
      description: 'A warm, translucent amber bead from the Baltic coast, prized for its beauty and supposed magical properties.',
      icon: '🟠'
    },
    {
      id: 'fc_bone_needle',
      name: 'Bone Sewing Needle',
      type: 'bone',
      era: 'medieval',
      culture: 'viking',
      baseValue: 90,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'frozen_cairn_frag_04',
      museumAppeal: 2,
      description: 'A thin bone needle with a drilled eye, used to sew clothing and sails.',
      icon: '🪡'
    },
    {
      id: 'fc_iron_axe_head',
      name: 'Iron Axe Head',
      type: 'weapon',
      era: 'medieval',
      culture: 'viking',
      baseValue: 350,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_05',
      museumAppeal: 4,
      description: 'A broad iron axe head with a flared cutting edge, dual-purpose as tool and weapon.',
      icon: '🪓'
    },
    {
      id: 'fc_comb_fragment',
      name: 'Antler Comb Fragment',
      type: 'bone',
      era: 'medieval',
      culture: 'viking',
      baseValue: 150,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'frozen_cairn_frag_06',
      museumAppeal: 3,
      description: 'Part of a composite comb made from riveted antler plates. Vikings took grooming seriously.',
      icon: '🦌'
    },
    {
      id: 'fc_soapstone_bowl',
      name: 'Soapstone Cooking Pot',
      type: 'pottery',
      era: 'medieval',
      culture: 'viking',
      baseValue: 200,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_07',
      museumAppeal: 3,
      description: 'A heavy soapstone vessel carved for direct-fire cooking, blackened on the exterior.',
      icon: '🥘'
    },
    {
      id: 'fc_glass_beads',
      name: 'Glass Bead String',
      type: 'jewelry',
      era: 'medieval',
      culture: 'viking',
      baseValue: 300,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'frozen_cairn_frag_08',
      museumAppeal: 5,
      description: 'Multicolored glass beads from a woman\'s necklace, some imported from as far as the Byzantine Empire.',
      icon: '📿'
    },
    {
      id: 'fc_spearhead',
      name: 'Pattern-Welded Spearhead',
      type: 'weapon',
      era: 'medieval',
      culture: 'viking',
      baseValue: 500,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_09',
      museumAppeal: 5,
      description: 'An iron spearhead showing a herringbone pattern from twisted steel rods welded together.',
      icon: '🔱'
    },
    {
      id: 'fc_rune_stone',
      name: 'Rune-Inscribed Stone',
      type: 'document',
      era: 'medieval',
      culture: 'viking',
      baseValue: 800,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_10',
      museumAppeal: 7,
      description: 'A flat stone carved with Elder Futhark runes commemorating the dead warrior within.',
      icon: 'ᚱ'
    },
    {
      id: 'fc_shield_boss',
      name: 'Iron Shield Boss',
      type: 'weapon',
      era: 'medieval',
      culture: 'viking',
      baseValue: 400,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_11',
      museumAppeal: 5,
      description: 'The domed iron center of a round shield, protecting the hand-grip behind it.',
      icon: '🛡️'
    },
    {
      id: 'fc_silver_arm_ring',
      name: 'Twisted Silver Arm Ring',
      type: 'jewelry',
      era: 'medieval',
      culture: 'viking',
      baseValue: 1200,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_12',
      museumAppeal: 7,
      description: 'A thick silver arm ring made from twisted rods, used as both ornament and portable wealth.',
      icon: '💍'
    },
    {
      id: 'fc_whale_bone_plaque',
      name: 'Whale Bone Plaque',
      type: 'art',
      era: 'medieval',
      culture: 'viking',
      baseValue: 700,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'frozen_cairn_frag_13',
      museumAppeal: 6,
      description: 'A flat whale bone panel carved with a scene of warriors feasting in Valhalla.',
      icon: '🐋'
    },
    {
      id: 'fc_iron_sword_blade',
      name: 'Ulfberht Sword Blade',
      type: 'weapon',
      era: 'medieval',
      culture: 'viking',
      baseValue: 3000,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_14',
      museumAppeal: 9,
      description: 'A high-carbon steel blade stamped +VLFBERH+T, one of the legendary Frankish-made swords.',
      icon: '⚔️'
    },
    {
      id: 'fc_bronze_brooch',
      name: 'Oval Tortoise Brooch',
      type: 'jewelry',
      era: 'medieval',
      culture: 'viking',
      baseValue: 1500,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_15',
      museumAppeal: 7,
      description: 'A domed oval brooch with intricate animal interlace, worn in pairs to fasten a woman\'s overdress.',
      icon: '🪲'
    },
    {
      id: 'fc_thor_hammer',
      name: 'Silver Thor\'s Hammer Pendant',
      type: 'religious',
      era: 'medieval',
      culture: 'viking',
      baseValue: 2000,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_16',
      museumAppeal: 8,
      description: 'A small silver Mjolnir pendant, the iconic symbol of the god Thor and Norse paganism.',
      icon: '🔨'
    },
    {
      id: 'fc_gold_foil_figure',
      name: 'Gold Foil Guldgubbe',
      type: 'art',
      era: 'medieval',
      culture: 'viking',
      baseValue: 5000,
      rarity: 'legendary',
      fragile: true,
      storyFragmentId: 'frozen_cairn_frag_17',
      museumAppeal: 9,
      description: 'A tiny stamped gold foil figure showing an embracing couple, possibly Frey and Gerd from Norse myth.',
      icon: '✨'
    },
    {
      id: 'fc_ship_plank',
      name: 'Preserved Ship Plank',
      type: 'structure',
      era: 'medieval',
      culture: 'viking',
      baseValue: 180,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_18',
      museumAppeal: 3,
      description: 'An oak plank from the burial ship, preserved by the frozen peat of the cairn.',
      icon: '🪵'
    },
    {
      id: 'fc_valkyrie_pendant',
      name: 'Silver Valkyrie Figurine',
      type: 'religious',
      era: 'medieval',
      culture: 'viking',
      baseValue: 7000,
      rarity: 'legendary',
      fragile: false,
      storyFragmentId: 'frozen_cairn_frag_19',
      museumAppeal: 10,
      description: 'A finely cast silver figurine of a Valkyrie holding a shield and offering a drinking horn.',
      icon: '🗡️'
    },
    {
      id: 'fc_lewis_chessman_style',
      name: 'Walrus Ivory Chess King',
      type: 'art',
      era: 'medieval',
      culture: 'viking',
      baseValue: 25000,
      rarity: 'mythical',
      fragile: true,
      storyFragmentId: 'frozen_cairn_frag_20',
      museumAppeal: 10,
      description: 'A carved walrus ivory chess king in the style of the Lewis Chessmen, with a worried expression and sword across his lap.',
      icon: '♚'
    },
  ],

  // ═══════════════════════════════════════════════════════════════
  // SITE 6: PHARAOH'S SHADOW — Egypt, minor tomb
  // ═══════════════════════════════════════════════════════════════
  pharaohs_shadow: [
    {
      id: 'ps_clay_shabti',
      name: 'Clay Shabti Figurine',
      type: 'religious',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 200,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_01',
      museumAppeal: 4,
      description: 'A crudely molded servant figure meant to labor in the afterlife on behalf of the deceased.',
      icon: '🧍'
    },
    {
      id: 'ps_pottery_sherd',
      name: 'Ostracon Pottery Shard',
      type: 'document',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 150,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_02',
      museumAppeal: 3,
      description: 'A pottery fragment used as scrap paper, bearing hieratic script listing workers\' rations.',
      icon: '📝'
    },
    {
      id: 'ps_faience_scarab',
      name: 'Blue Faience Scarab',
      type: 'religious',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 300,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_03',
      museumAppeal: 5,
      description: 'A glazed ceramic beetle amulet symbolizing rebirth, with a prayer inscribed on the flat base.',
      icon: '🪲'
    },
    {
      id: 'ps_linen_wrapping',
      name: 'Linen Mummy Wrapping',
      type: 'art',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 180,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_04',
      museumAppeal: 3,
      description: 'A strip of fine linen wrapping with hieratic text from the Book of the Dead.',
      icon: '🩹'
    },
    {
      id: 'ps_alabaster_jar',
      name: 'Alabaster Cosmetic Jar',
      type: 'pottery',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 250,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_05',
      museumAppeal: 4,
      description: 'A small translucent alabaster vessel that once held kohl eyeliner or scented unguent.',
      icon: '🏺'
    },
    {
      id: 'ps_copper_chisel',
      name: 'Copper Chisel',
      type: 'tool',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 160,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'pharaohs_shadow_frag_06',
      museumAppeal: 2,
      description: 'A simple copper chisel used by tomb workers to carve limestone walls.',
      icon: '🔨'
    },
    {
      id: 'ps_bread_mold',
      name: 'Ceramic Bread Mold',
      type: 'pottery',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 120,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_07',
      museumAppeal: 2,
      description: 'A cone-shaped clay mold for baking bread, the staple of every Egyptian worker\'s diet.',
      icon: '🍞'
    },
    {
      id: 'ps_amulet_eye_of_horus',
      name: 'Eye of Horus Amulet',
      type: 'religious',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 400,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_08',
      museumAppeal: 6,
      description: 'A faience wedjat eye amulet placed among the wrappings to protect the deceased.',
      icon: '👁️'
    },
    {
      id: 'ps_bronze_mirror',
      name: 'Polished Bronze Mirror',
      type: 'tool',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 500,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'pharaohs_shadow_frag_09',
      museumAppeal: 5,
      description: 'A disc-shaped bronze mirror with a carved handle in the form of a papyrus column.',
      icon: '🪞'
    },
    {
      id: 'ps_limestone_stele',
      name: 'Limestone False Door Stele',
      type: 'structure',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 600,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'pharaohs_shadow_frag_10',
      museumAppeal: 6,
      description: 'A carved stone slab depicting a door through which the dead could receive offerings.',
      icon: '🚪'
    },
    {
      id: 'ps_glass_beads',
      name: 'Faience Bead Collar',
      type: 'jewelry',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 350,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_11',
      museumAppeal: 5,
      description: 'Hundreds of tiny faience beads in blue, green, and white forming a broad ceremonial collar.',
      icon: '📿'
    },
    {
      id: 'ps_canopic_jar',
      name: 'Canopic Jar with Jackal Lid',
      type: 'religious',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 1500,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_12',
      museumAppeal: 8,
      description: 'An alabaster jar topped with a jackal-headed lid representing Duamutef, protector of the stomach.',
      icon: '🐺'
    },
    {
      id: 'ps_hieroglyphic_tablet',
      name: 'Hieroglyphic Offering Tablet',
      type: 'document',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 1200,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'pharaohs_shadow_frag_13',
      museumAppeal: 7,
      description: 'A stone slab carved with the offering formula, naming the tomb owner and their titles.',
      icon: '📜'
    },
    {
      id: 'ps_faience_ushabti',
      name: 'Glazed Faience Ushabti',
      type: 'religious',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 800,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_14',
      museumAppeal: 6,
      description: 'A finely glazed turquoise servant figure holding miniature farming tools.',
      icon: '🗿'
    },
    {
      id: 'ps_ivory_headrest',
      name: 'Ivory Headrest',
      type: 'art',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 1000,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_15',
      museumAppeal: 6,
      description: 'A carved ivory headrest used as a pillow, believed to protect the sleeping person from evil spirits.',
      icon: '🛏️'
    },
    {
      id: 'ps_gold_earring',
      name: 'Gold Hoop Earring',
      type: 'jewelry',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 2000,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'pharaohs_shadow_frag_16',
      museumAppeal: 7,
      description: 'A thick gold hoop earring with granulation decoration, from the tomb of a minor noble.',
      icon: '💍'
    },
    {
      id: 'ps_painted_coffin_panel',
      name: 'Painted Coffin Panel',
      type: 'art',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 3500,
      rarity: 'legendary',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_17',
      museumAppeal: 9,
      description: 'A wooden panel from the inner coffin, painted with the goddess Nut spreading her wings protectively.',
      icon: '🎨'
    },
    {
      id: 'ps_heart_scarab',
      name: 'Stone Heart Scarab',
      type: 'religious',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 5000,
      rarity: 'legendary',
      fragile: false,
      storyFragmentId: 'pharaohs_shadow_frag_18',
      museumAppeal: 9,
      description: 'A large green stone scarab inscribed with a spell from the Book of the Dead, placed over the heart to ensure favorable judgment.',
      icon: '💚'
    },
    {
      id: 'ps_bronze_cat',
      name: 'Bronze Bastet Statue',
      type: 'religious',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 180,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'pharaohs_shadow_frag_19',
      museumAppeal: 5,
      description: 'A small bronze cat figurine representing the goddess Bastet, protector of the household.',
      icon: '🐱'
    },
    {
      id: 'ps_golden_pectoral',
      name: 'Gold Winged Pectoral',
      type: 'jewelry',
      era: 'ancient',
      culture: 'egyptian',
      baseValue: 30000,
      rarity: 'mythical',
      fragile: true,
      storyFragmentId: 'pharaohs_shadow_frag_20',
      museumAppeal: 10,
      description: 'A broad gold chest ornament with inlaid lapis and carnelian depicting a winged scarab pushing the sun disc.',
      icon: '🦅'
    },
  ],

  // ═══════════════════════════════════════════════════════════════
  // SITE 7: OBSIDIAN FORGE — Japan, samurai-era forge
  // ═══════════════════════════════════════════════════════════════
  obsidian_forge: [
    {
      id: 'of_iron_slag',
      name: 'Iron Slag Fragment',
      type: 'tool',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 80,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_01',
      museumAppeal: 1,
      description: 'A chunk of waste iron slag from the smelting process, showing the forge was active for years.',
      icon: '🔥'
    },
    {
      id: 'of_ceramic_sherd',
      name: 'Seto Ware Pottery Shard',
      type: 'pottery',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 120,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'obsidian_forge_frag_02',
      museumAppeal: 2,
      description: 'A fragment of ash-glazed Seto pottery from a utilitarian bowl or plate.',
      icon: '🍶'
    },
    {
      id: 'of_charcoal_pit',
      name: 'Tatara Charcoal Remnant',
      type: 'structure',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 100,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_03',
      museumAppeal: 2,
      description: 'Hardened remnant from a charcoal pit used to fuel the traditional tatara smelting furnace.',
      icon: '⬛'
    },
    {
      id: 'of_iron_tsuba',
      name: 'Iron Sword Guard (Tsuba)',
      type: 'weapon',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 350,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_04',
      museumAppeal: 5,
      description: 'A round iron hand guard with a simple mokko shape, pitted but intact.',
      icon: '⭕'
    },
    {
      id: 'of_stone_mortar',
      name: 'Stone Grinding Mortar',
      type: 'tool',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 130,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_05',
      museumAppeal: 2,
      description: 'A heavy stone mortar used to grind iron sand before smelting.',
      icon: '🪨'
    },
    {
      id: 'of_bronze_bell_frag',
      name: 'Dotaku Bell Fragment',
      type: 'religious',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 400,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_06',
      museumAppeal: 5,
      description: 'A fragment of a thin bronze ritual bell decorated with flowing water patterns.',
      icon: '🔔'
    },
    {
      id: 'of_tenmoku_bowl',
      name: 'Tenmoku Tea Bowl',
      type: 'pottery',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 600,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'obsidian_forge_frag_07',
      museumAppeal: 6,
      description: 'A dark-glazed tea bowl with streaks of iron-rich "rabbit fur" patterning, prized by tea masters.',
      icon: '🍵'
    },
    {
      id: 'of_iron_arrowhead',
      name: 'Iron Yanone Arrowhead',
      type: 'weapon',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 200,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_08',
      museumAppeal: 3,
      description: 'A leaf-shaped iron arrowhead designed to penetrate light armor.',
      icon: '🏹'
    },
    {
      id: 'of_clay_figurine',
      name: 'Haniwa Warrior Fragment',
      type: 'art',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 450,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'obsidian_forge_frag_09',
      museumAppeal: 6,
      description: 'The upper body of a hollow clay warrior figure originally placed on a burial mound.',
      icon: '🗿'
    },
    {
      id: 'of_copper_coin',
      name: 'Kanei Tsuho Coin',
      type: 'coin',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 100,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_10',
      museumAppeal: 3,
      description: 'A round copper coin with a square hole, bearing four kanji characters.',
      icon: '🪙'
    },
    {
      id: 'of_lacquer_fragment',
      name: 'Red Lacquerware Fragment',
      type: 'art',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 350,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'obsidian_forge_frag_11',
      museumAppeal: 5,
      description: 'A piece of vermilion lacquered wood showing gold-dust maki-e decoration of pine branches.',
      icon: '🔴'
    },
    {
      id: 'of_katana_tang',
      name: 'Katana Tang with Signature',
      type: 'weapon',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 1500,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_12',
      museumAppeal: 8,
      description: 'The hidden tang of a katana blade bearing the swordsmith\'s chiseled signature and date.',
      icon: '⚔️'
    },
    {
      id: 'of_iron_helmet_piece',
      name: 'Kabuto Helmet Plate',
      type: 'weapon',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 800,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_13',
      museumAppeal: 6,
      description: 'A riveted iron plate from a multi-plate samurai helmet, still showing traces of lacquer.',
      icon: '🪖'
    },
    {
      id: 'of_celadon_incense',
      name: 'Celadon Incense Burner',
      type: 'religious',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 700,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'obsidian_forge_frag_14',
      museumAppeal: 6,
      description: 'A three-legged celadon incense burner with a pierced lid, used in Buddhist temple ceremonies.',
      icon: '🕯️'
    },
    {
      id: 'of_gold_tsuba',
      name: 'Gold-Inlaid Tsuba',
      type: 'weapon',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 3000,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_15',
      museumAppeal: 8,
      description: 'An iron sword guard with gold nunome-zogan inlay depicting dragons in clouds.',
      icon: '🐉'
    },
    {
      id: 'of_netsuke',
      name: 'Ivory Netsuke Toggle',
      type: 'art',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 2000,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'obsidian_forge_frag_16',
      museumAppeal: 7,
      description: 'A miniature carved ivory toggle in the shape of a coiled dragon, worn at the belt to secure a pouch.',
      icon: '🎎'
    },
    {
      id: 'of_tamahagane',
      name: 'Tamahagane Steel Billet',
      type: 'tool',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 1800,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_17',
      museumAppeal: 7,
      description: 'A lump of the legendary jewel steel produced in a tatara furnace, the raw material of the finest swords.',
      icon: '💎'
    },
    {
      id: 'of_golden_shachi',
      name: 'Gold Shachihoko Ornament',
      type: 'art',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 8000,
      rarity: 'legendary',
      fragile: true,
      storyFragmentId: 'obsidian_forge_frag_18',
      museumAppeal: 9,
      description: 'A gilded bronze fish-tiger roof ornament from a castle, believed to protect against fire.',
      icon: '🐟'
    },
    {
      id: 'of_masamune_blade',
      name: 'Masamune-School Blade Fragment',
      type: 'weapon',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 15000,
      rarity: 'legendary',
      fragile: false,
      storyFragmentId: 'obsidian_forge_frag_19',
      museumAppeal: 10,
      description: 'A broken blade section showing the distinctive nie grain of the Masamune school, the greatest swordsmiths in Japanese history.',
      icon: '🗡️'
    },
    {
      id: 'of_imperial_chrysanthemum',
      name: 'Imperial Chrysanthemum Seal',
      type: 'document',
      era: 'medieval',
      culture: 'japanese',
      baseValue: 35000,
      rarity: 'mythical',
      fragile: true,
      storyFragmentId: 'obsidian_forge_frag_20',
      museumAppeal: 10,
      description: 'A gold chrysanthemum seal from an imperial commission, granting the forge the right to produce swords for the court.',
      icon: '🌸'
    },
  ],

  // ═══════════════════════════════════════════════════════════════
  // SITE 8: ATLANTEAN SHELF — Mediterranean, underwater ruins
  // ═══════════════════════════════════════════════════════════════
  atlantean_shelf: [
    {
      id: 'as_amphora_shard',
      name: 'Transport Amphora Shard',
      type: 'pottery',
      era: 'classical',
      culture: 'greek',
      baseValue: 100,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_01',
      museumAppeal: 2,
      description: 'A thick pottery fragment from a wine amphora, encrusted with barnacles from centuries on the seabed.',
      icon: '🏺'
    },
    {
      id: 'as_bronze_nail',
      name: 'Bronze Ship Nail',
      type: 'tool',
      era: 'classical',
      culture: 'greek',
      baseValue: 90,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_02',
      museumAppeal: 1,
      description: 'A square-shanked bronze nail from a shipwreck, green with patina but perfectly preserved.',
      icon: '📌'
    },
    {
      id: 'as_marble_hand',
      name: 'Marble Statue Hand',
      type: 'art',
      era: 'classical',
      culture: 'greek',
      baseValue: 300,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'atlantean_shelf_frag_03',
      museumAppeal: 4,
      description: 'A severed marble hand from a life-size statue, fingers delicately posed.',
      icon: '✋'
    },
    {
      id: 'as_lead_anchor',
      name: 'Lead Anchor Stock',
      type: 'tool',
      era: 'classical',
      culture: 'greek',
      baseValue: 200,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_04',
      museumAppeal: 3,
      description: 'A heavy lead crossbar from a wooden anchor, stamped with the ship owner\'s name.',
      icon: '⚓'
    },
    {
      id: 'as_oil_lamp',
      name: 'Terracotta Oil Lamp',
      type: 'pottery',
      era: 'classical',
      culture: 'greek',
      baseValue: 170,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'atlantean_shelf_frag_05',
      museumAppeal: 3,
      description: 'A small molded clay oil lamp with a relief of a running athlete on the discus.',
      icon: '🪔'
    },
    {
      id: 'as_column_drum',
      name: 'Fluted Column Drum',
      type: 'structure',
      era: 'classical',
      culture: 'greek',
      baseValue: 250,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_06',
      museumAppeal: 4,
      description: 'A section of a Doric column, its fluting still sharp despite seawater erosion.',
      icon: '🏛️'
    },
    {
      id: 'as_bronze_coin',
      name: 'Corroded Bronze Obol',
      type: 'coin',
      era: 'classical',
      culture: 'greek',
      baseValue: 150,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_07',
      museumAppeal: 3,
      description: 'A small bronze coin bearing the owl of Athens, heavily corroded by seawater.',
      icon: '🪙'
    },
    {
      id: 'as_glass_unguentarium',
      name: 'Glass Unguentarium',
      type: 'art',
      era: 'classical',
      culture: 'mediterranean',
      baseValue: 400,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'atlantean_shelf_frag_08',
      museumAppeal: 5,
      description: 'A slender glass perfume flask that has turned iridescent from centuries underwater.',
      icon: '🧴'
    },
    {
      id: 'as_silver_tetradrachm',
      name: 'Silver Tetradrachm',
      type: 'coin',
      era: 'classical',
      culture: 'greek',
      baseValue: 800,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_09',
      museumAppeal: 6,
      description: 'A silver coin showing Athena on one side and her owl on the reverse, a standard of ancient trade.',
      icon: '🦉'
    },
    {
      id: 'as_bronze_helm',
      name: 'Corinthian Bronze Helmet',
      type: 'weapon',
      era: 'classical',
      culture: 'greek',
      baseValue: 2000,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_10',
      museumAppeal: 8,
      description: 'A full-face bronze helmet with nose guard and cheek plates, green with marine patina.',
      icon: '🪖'
    },
    {
      id: 'as_marble_torso',
      name: 'Marble Torso Fragment',
      type: 'art',
      era: 'classical',
      culture: 'greek',
      baseValue: 1500,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'atlantean_shelf_frag_11',
      museumAppeal: 7,
      description: 'The muscular torso of a male statue, likely an athlete or deity, carved in Parian marble.',
      icon: '🗿'
    },
    {
      id: 'as_amphora_intact',
      name: 'Intact Wine Amphora',
      type: 'pottery',
      era: 'classical',
      culture: 'greek',
      baseValue: 600,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'atlantean_shelf_frag_12',
      museumAppeal: 5,
      description: 'A complete two-handled transport amphora still sealed with its original pitch stopper.',
      icon: '🍷'
    },
    {
      id: 'as_mosaic_floor',
      name: 'Submerged Mosaic Section',
      type: 'structure',
      era: 'classical',
      culture: 'greek',
      baseValue: 450,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'atlantean_shelf_frag_13',
      museumAppeal: 6,
      description: 'A section of floor mosaic depicting Poseidon with his trident, partially obscured by marine growth.',
      icon: '🔱'
    },
    {
      id: 'as_gold_ring',
      name: 'Gold Signet Ring',
      type: 'jewelry',
      era: 'classical',
      culture: 'greek',
      baseValue: 2500,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_14',
      museumAppeal: 8,
      description: 'A heavy gold ring with an intaglio carving of a warship, likely belonging to a naval commander.',
      icon: '💍'
    },
    {
      id: 'as_inscription_block',
      name: 'Greek Inscription Block',
      type: 'document',
      era: 'classical',
      culture: 'greek',
      baseValue: 700,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_15',
      museumAppeal: 6,
      description: 'A marble block with deeply carved Greek text recording a public decree.',
      icon: '📜'
    },
    {
      id: 'as_bronze_poseidon',
      name: 'Bronze Poseidon Statuette',
      type: 'religious',
      era: 'classical',
      culture: 'greek',
      baseValue: 4000,
      rarity: 'legendary',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_16',
      museumAppeal: 9,
      description: 'A 30cm bronze figure of Poseidon hurling his trident, remarkably preserved by anoxic seabed mud.',
      icon: '🔱'
    },
    {
      id: 'as_golden_wreath',
      name: 'Gold Olive Wreath',
      type: 'jewelry',
      era: 'classical',
      culture: 'greek',
      baseValue: 6000,
      rarity: 'legendary',
      fragile: true,
      storyFragmentId: 'atlantean_shelf_frag_17',
      museumAppeal: 10,
      description: 'A delicate wreath of hammered gold olive leaves, perhaps an athletic or military prize.',
      icon: '👑'
    },
    {
      id: 'as_surgical_tools',
      name: 'Bronze Surgical Kit',
      type: 'tool',
      era: 'classical',
      culture: 'greek',
      baseValue: 1800,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'atlantean_shelf_frag_18',
      museumAppeal: 7,
      description: 'A set of bronze medical instruments including a scalpel, probe, and bone lever.',
      icon: '⚕️'
    },
    {
      id: 'as_marble_aphrodite',
      name: 'Marble Head of Aphrodite',
      type: 'art',
      era: 'classical',
      culture: 'greek',
      baseValue: 180,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'atlantean_shelf_frag_19',
      museumAppeal: 5,
      description: 'A small marble head with serene expression and wavy hair, broken from a larger statue.',
      icon: '👩'
    },
    {
      id: 'as_antikythera_gear',
      name: 'Bronze Gear Mechanism',
      type: 'tool',
      era: 'classical',
      culture: 'greek',
      baseValue: 40000,
      rarity: 'mythical',
      fragile: true,
      storyFragmentId: 'atlantean_shelf_frag_20',
      museumAppeal: 10,
      description: 'An intricate bronze gear assembly resembling an astronomical calculator. Ancient technology that shouldn\'t exist for another millennium.',
      icon: '⚙️'
    },
  ],

  // ═══════════════════════════════════════════════════════════════
  // SITE 9: LIBRARY OF SANDS — Sahara, lost library
  // ═══════════════════════════════════════════════════════════════
  library_of_sands: [
    {
      id: 'ls_clay_tablet',
      name: 'Clay Inventory Tablet',
      type: 'document',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 200,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_01',
      museumAppeal: 3,
      description: 'A small clay tablet listing stored scroll quantities in an unknown tally system.',
      icon: '📋'
    },
    {
      id: 'ls_stone_lamp',
      name: 'Sandstone Oil Lamp',
      type: 'tool',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 120,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'library_of_sands_frag_02',
      museumAppeal: 2,
      description: 'A carved sandstone lamp with a blackened spout, used to read by in the windowless library halls.',
      icon: '🪔'
    },
    {
      id: 'ls_reed_pen',
      name: 'Reed Writing Pen',
      type: 'tool',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 90,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_03',
      museumAppeal: 2,
      description: 'A dried reed pen with a split nib, stained with ancient carbon ink.',
      icon: '✒️'
    },
    {
      id: 'ls_ink_pot',
      name: 'Ceramic Ink Pot',
      type: 'pottery',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 150,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_04',
      museumAppeal: 3,
      description: 'A small ceramic vessel with dried ink residue inside, used by scribes.',
      icon: '🫙'
    },
    {
      id: 'ls_scroll_case',
      name: 'Bronze Scroll Case',
      type: 'tool',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 300,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'library_of_sands_frag_05',
      museumAppeal: 4,
      description: 'A cylindrical bronze case for protecting scrolls during transport across the desert.',
      icon: '🗞️'
    },
    {
      id: 'ls_stone_seal',
      name: 'Library Seal Stone',
      type: 'document',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 350,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'library_of_sands_frag_06',
      museumAppeal: 5,
      description: 'A carved stone cylinder seal bearing the library\'s insignia, used to mark official documents.',
      icon: '🔏'
    },
    {
      id: 'ls_papyrus_fragment',
      name: 'Papyrus Text Fragment',
      type: 'document',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 400,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_07',
      museumAppeal: 5,
      description: 'A fragment of papyrus bearing mathematical calculations and geometric diagrams.',
      icon: '📜'
    },
    {
      id: 'ls_glass_bead_abacus',
      name: 'Glass Bead Abacus Frame',
      type: 'tool',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 280,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_08',
      museumAppeal: 4,
      description: 'A wooden frame with glass beads on wire, a counting device used by the library\'s scholars.',
      icon: '🧮'
    },
    {
      id: 'ls_obsidian_lens',
      name: 'Polished Obsidian Lens',
      type: 'tool',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 500,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_09',
      museumAppeal: 6,
      description: 'A carefully ground obsidian disc that magnifies text, suggesting advanced optical knowledge.',
      icon: '🔍'
    },
    {
      id: 'ls_terracotta_shelf_marker',
      name: 'Terracotta Shelf Label',
      type: 'pottery',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 130,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_10',
      museumAppeal: 3,
      description: 'A clay label tag incised with a subject category, hung from a scroll shelf.',
      icon: '🏷️'
    },
    {
      id: 'ls_astronomical_disc',
      name: 'Bronze Astronomical Disc',
      type: 'tool',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 1500,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'library_of_sands_frag_11',
      museumAppeal: 8,
      description: 'A flat bronze disc engraved with star positions and seasonal markers, a desert navigation tool.',
      icon: '🌟'
    },
    {
      id: 'ls_unknown_script_tablet',
      name: 'Unknown Script Tablet',
      type: 'document',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 1200,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_12',
      museumAppeal: 8,
      description: 'A stone tablet covered in a writing system that matches no known language. A linguistic mystery.',
      icon: '❓'
    },
    {
      id: 'ls_copper_sundial',
      name: 'Copper Pocket Sundial',
      type: 'tool',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 800,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'library_of_sands_frag_13',
      museumAppeal: 6,
      description: 'A portable folding sundial with latitude markings for multiple locations across North Africa.',
      icon: '☀️'
    },
    {
      id: 'ls_leather_map',
      name: 'Leather Trade Route Map',
      type: 'document',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 2000,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_14',
      museumAppeal: 8,
      description: 'A desiccated leather scroll showing oasis locations and caravan routes across the Sahara.',
      icon: '🗺️'
    },
    {
      id: 'ls_bone_ruler',
      name: 'Calibrated Bone Ruler',
      type: 'bone',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 250,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_15',
      museumAppeal: 3,
      description: 'A flat bone strip with precise measurement markings, a scholar\'s drafting tool.',
      icon: '📏'
    },
    {
      id: 'ls_gold_scholar_ring',
      name: 'Scholar\'s Gold Ring',
      type: 'jewelry',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 1800,
      rarity: 'rare',
      fragile: false,
      storyFragmentId: 'library_of_sands_frag_16',
      museumAppeal: 7,
      description: 'A gold ring engraved with the library\'s motto, worn by senior scholars as a mark of rank.',
      icon: '💍'
    },
    {
      id: 'ls_crystal_prism',
      name: 'Quartz Crystal Prism',
      type: 'tool',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 3000,
      rarity: 'legendary',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_17',
      museumAppeal: 9,
      description: 'A precisely cut quartz prism that splits light into its component colors, suggesting knowledge of optics far ahead of its time.',
      icon: '🔮'
    },
    {
      id: 'ls_astronomical_codex',
      name: 'Astronomical Codex',
      type: 'document',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 5000,
      rarity: 'legendary',
      fragile: true,
      storyFragmentId: 'library_of_sands_frag_18',
      museumAppeal: 10,
      description: 'A bound volume of star charts predicting eclipses with disturbing accuracy. The mathematics within are centuries ahead of their era.',
      icon: '📕'
    },
    {
      id: 'ls_wall_inscription',
      name: 'Foundation Wall Inscription',
      type: 'structure',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 220,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'library_of_sands_frag_19',
      museumAppeal: 4,
      description: 'A carved stone block from the library wall bearing a dedication text by its unknown founder.',
      icon: '🧱'
    },
    {
      id: 'ls_rosetta_analogue',
      name: 'Trilingual Translation Stone',
      type: 'document',
      era: 'ancient',
      culture: 'saharan',
      baseValue: 50000,
      rarity: 'mythical',
      fragile: false,
      storyFragmentId: 'library_of_sands_frag_20',
      museumAppeal: 10,
      description: 'A stone slab bearing the same text in the unknown Saharan script, Egyptian hieroglyphs, and Greek. The key to deciphering a lost language.',
      icon: '🪨'
    },
  ],

  // ═══════════════════════════════════════════════════════════════
  // SITE 10: GENESIS CAVERN — Ethiopia, oldest site
  // ═══════════════════════════════════════════════════════════════
  genesis_cavern: [
    {
      id: 'gc_stone_flake',
      name: 'Oldowan Stone Flake',
      type: 'tool',
      era: 'proto_human',
      culture: 'proto_human',
      baseValue: 100,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'genesis_cavern_frag_01',
      museumAppeal: 3,
      description: 'A simple stone flake struck from a core, among the earliest deliberately made tools on Earth.',
      icon: '🪨'
    },
    {
      id: 'gc_hammerstone',
      name: 'Basalt Hammerstone',
      type: 'tool',
      era: 'proto_human',
      culture: 'proto_human',
      baseValue: 120,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'genesis_cavern_frag_02',
      museumAppeal: 3,
      description: 'A rounded basalt cobble with impact marks, used to strike flakes from stone cores.',
      icon: '🪨'
    },
    {
      id: 'gc_animal_bone',
      name: 'Cut-Marked Animal Bone',
      type: 'bone',
      era: 'proto_human',
      culture: 'proto_human',
      baseValue: 150,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_03',
      museumAppeal: 4,
      description: 'An antelope leg bone bearing unmistakable stone tool cut marks, proof of early meat processing.',
      icon: '🦴'
    },
    {
      id: 'gc_ochre_lump',
      name: 'Red Ochre Pigment Lump',
      type: 'art',
      era: 'prehistoric',
      culture: 'proto_human',
      baseValue: 200,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'genesis_cavern_frag_04',
      museumAppeal: 4,
      description: 'A chunk of iron oxide with scraping marks, used to produce red pigment for body painting or art.',
      icon: '🔴'
    },
    {
      id: 'gc_chopper_core',
      name: 'Chopper Core Tool',
      type: 'tool',
      era: 'proto_human',
      culture: 'proto_human',
      baseValue: 130,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'genesis_cavern_frag_05',
      museumAppeal: 3,
      description: 'A cobble with one end deliberately chipped to create a crude cutting edge.',
      icon: '🪓'
    },
    {
      id: 'gc_tooth',
      name: 'Hominin Molar Tooth',
      type: 'bone',
      era: 'proto_human',
      culture: 'proto_human',
      baseValue: 500,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_06',
      museumAppeal: 7,
      description: 'A large, thick-enameled molar that could belong to an early Homo species. Dietary analysis is possible.',
      icon: '🦷'
    },
    {
      id: 'gc_fire_hearth',
      name: 'Charred Hearth Remnant',
      type: 'structure',
      era: 'prehistoric',
      culture: 'proto_human',
      baseValue: 250,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'genesis_cavern_frag_07',
      museumAppeal: 5,
      description: 'A patch of charcoal and burned bone fragments from a controlled fire, evidence of early fire use.',
      icon: '🔥'
    },
    {
      id: 'gc_shell_ornament',
      name: 'Perforated Shell Bead',
      type: 'jewelry',
      era: 'prehistoric',
      culture: 'proto_human',
      baseValue: 600,
      rarity: 'uncommon',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_08',
      museumAppeal: 7,
      description: 'A tiny marine shell with a deliberately drilled hole, among the earliest evidence of symbolic thinking.',
      icon: '🐚'
    },
    {
      id: 'gc_handaxe',
      name: 'Acheulean Handaxe',
      type: 'tool',
      era: 'proto_human',
      culture: 'proto_human',
      baseValue: 350,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'genesis_cavern_frag_09',
      museumAppeal: 6,
      description: 'A symmetrical teardrop-shaped stone tool, showing the leap in cognitive ability from crude choppers to planned design.',
      icon: '🪨'
    },
    {
      id: 'gc_eggshell_beads',
      name: 'Ostrich Eggshell Beads',
      type: 'jewelry',
      era: 'prehistoric',
      culture: 'proto_human',
      baseValue: 300,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_10',
      museumAppeal: 5,
      description: 'Tiny disc beads ground from ostrich eggshell, a tradition that persists in Africa to this day.',
      icon: '🥚'
    },
    {
      id: 'gc_bone_tool',
      name: 'Bone Digging Stick',
      type: 'bone',
      era: 'prehistoric',
      culture: 'proto_human',
      baseValue: 200,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_11',
      museumAppeal: 3,
      description: 'A large animal bone shaped and polished at one end for digging tubers from hard ground.',
      icon: '🦴'
    },
    {
      id: 'gc_cave_art_slab',
      name: 'Engraved Cave Art Slab',
      type: 'art',
      era: 'prehistoric',
      culture: 'proto_human',
      baseValue: 1500,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_12',
      museumAppeal: 8,
      description: 'A flat stone slab with crosshatch engravings, possibly the oldest abstract art in existence.',
      icon: '🎨'
    },
    {
      id: 'gc_ochre_crayon',
      name: 'Shaped Ochre Crayon',
      type: 'art',
      era: 'prehistoric',
      culture: 'proto_human',
      baseValue: 400,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'genesis_cavern_frag_13',
      museumAppeal: 5,
      description: 'A stick of red ochre deliberately shaped to a point for drawing on cave walls.',
      icon: '🖍️'
    },
    {
      id: 'gc_blade_cache',
      name: 'Microblade Cache',
      type: 'tool',
      era: 'prehistoric',
      culture: 'proto_human',
      baseValue: 350,
      rarity: 'uncommon',
      fragile: false,
      storyFragmentId: 'genesis_cavern_frag_14',
      museumAppeal: 5,
      description: 'A cluster of tiny, precisely struck stone blades meant to be hafted into composite tools.',
      icon: '🔪'
    },
    {
      id: 'gc_pollen_core',
      name: 'Sediment Pollen Core',
      type: 'bone',
      era: 'proto_human',
      culture: 'proto_human',
      baseValue: 180,
      rarity: 'common',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_15',
      museumAppeal: 2,
      description: 'A cylinder of cave sediment rich in ancient pollen, a time capsule of the paleoclimate.',
      icon: '🌿'
    },
    {
      id: 'gc_finger_bone',
      name: 'Hominin Finger Bone',
      type: 'bone',
      era: 'proto_human',
      culture: 'proto_human',
      baseValue: 2500,
      rarity: 'rare',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_16',
      museumAppeal: 9,
      description: 'A small phalanx bone with proportions suggesting a previously unknown hominin species.',
      icon: '🦴'
    },
    {
      id: 'gc_venus_figurine',
      name: 'Stone Venus Figurine',
      type: 'art',
      era: 'prehistoric',
      culture: 'proto_human',
      baseValue: 5000,
      rarity: 'legendary',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_17',
      museumAppeal: 10,
      description: 'A small carved stone figure of a female form with exaggerated features, a fertility symbol of astonishing age.',
      icon: '🗿'
    },
    {
      id: 'gc_bone_flute',
      name: 'Bone Flute',
      type: 'art',
      era: 'prehistoric',
      culture: 'proto_human',
      baseValue: 8000,
      rarity: 'legendary',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_18',
      museumAppeal: 10,
      description: 'A hollow bird bone with four precisely placed finger holes. The oldest musical instrument ever found.',
      icon: '🎵'
    },
    {
      id: 'gc_worked_crystal',
      name: 'Quartz Crystal Hand Tool',
      type: 'tool',
      era: 'proto_human',
      culture: 'proto_human',
      baseValue: 250,
      rarity: 'common',
      fragile: false,
      storyFragmentId: 'genesis_cavern_frag_19',
      museumAppeal: 4,
      description: 'A quartz crystal deliberately shaped into a cutting tool, chosen perhaps for its unusual clarity.',
      icon: '💎'
    },
    {
      id: 'gc_skull_fragment',
      name: 'Archaic Hominin Skull Fragment',
      type: 'bone',
      era: 'proto_human',
      culture: 'proto_human',
      baseValue: 45000,
      rarity: 'mythical',
      fragile: true,
      storyFragmentId: 'genesis_cavern_frag_20',
      museumAppeal: 10,
      description: 'A section of cranium with a brow ridge unlike any known species. This could rewrite the human family tree.',
      icon: '💀'
    },
  ],
};

// ── Lookup helper ──

const _allArtifacts: Map<string, ArtifactDef> = new Map();

for (const siteArtifacts of Object.values(ARTIFACT_POOLS)) {
  for (const artifact of siteArtifacts) {
    _allArtifacts.set(artifact.id, artifact);
  }
}

export function getArtifactDef(id: string): ArtifactDef | undefined {
  return _allArtifacts.get(id);
}
